/**
 * @flow
 * @relayHash 4ce3cdcbc912d144d7cf3a1ac850c393
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type LeaderboardDetailsGetGameByIdQueryVariables = {|
  id: string
|};
export type LeaderboardDetailsGetGameByIdQueryResponse = {|
  +findGameById: ?{|
    +data: ?{|
      +name: ?string,
      +game_quarter_label: ?string,
      +game_type_id: ?string,
      +quarters: ?$ReadOnlyArray<?{|
        +quarter_name: ?string
      |}>,
    |}
  |}
|};
export type LeaderboardDetailsGetGameByIdQuery = {|
  variables: LeaderboardDetailsGetGameByIdQueryVariables,
  response: LeaderboardDetailsGetGameByIdQueryResponse,
|};
*/


/*
query LeaderboardDetailsGetGameByIdQuery(
  $id: ID!
) {
  findGameById(id: $id) {
    data {
      name
      game_quarter_label
      game_type_id
      quarters {
        quarter_name
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "findGameById",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "findGameById",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "data",
        "storageKey": null,
        "args": null,
        "concreteType": "game",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "name",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "game_quarter_label",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "game_type_id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "quarters",
            "storageKey": null,
            "args": null,
            "concreteType": "gameSettingsType",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "quarter_name",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "LeaderboardDetailsGetGameByIdQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "LeaderboardDetailsGetGameByIdQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "LeaderboardDetailsGetGameByIdQuery",
    "id": null,
    "text": "query LeaderboardDetailsGetGameByIdQuery(\n  $id: ID!\n) {\n  findGameById(id: $id) {\n    data {\n      name\n      game_quarter_label\n      game_type_id\n      quarters {\n        quarter_name\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'fd35d0dd388e0c7428f2dfaf22479b60';
module.exports = node;
